import uri from "@/scripts/Utils/uri";
import { usePage } from "@inertiajs/react";
import { useState } from "react";

const locales = {
  en: {
    label: "English",
  },
  es: {
    label: "Español",
  },
};

interface Props {
  className?: string;
}

export default function LanguageSelector({ className }: Props) {
  const {
    locale,
    currentRouteName,
    currentParams,
    routeNames,
    alternativeUrls,
  } = usePage<{
    locale: string;
    currentParams: { [key: string]: any };
    currentRouteName: string;
    routeNames: { [key: string]: any };
    alternativeUrls?: { [key: string]: any } | null;
  }>().props;
  const [open, setOpen] = useState(false);

  function toggleSelector() {
    setOpen((old) => !old);
  }

  return (
    <div
      className={`relative text-base ring-1 ring-muted text-white ${className}`}
    >
      <button
        className="flex items-center justify-between w-full px-5 py-3"
        onClick={() => toggleSelector()}
      >
        <p className="flex items-center gap-2">
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            xmlns="http://www.w3.org/2000/svg"
            className="text-muted"
          >
            <path
              d="M8 14.5667C7.16496 14.5667 6.37885 14.4085 5.64168 14.0923C4.90451 13.7761 4.26027 13.3423 3.70898 12.791C3.15771 12.2397 2.72395 11.5955 2.40772 10.8583C2.09147 10.1212 1.93335 9.33504 1.93335 8.5C1.93335 7.65812 2.09147 6.87031 2.40772 6.13655C2.72395 5.40279 3.15771 4.76027 3.70898 4.20898C4.26027 3.65771 4.90451 3.22395 5.64168 2.90772C6.37885 2.59147 7.16496 2.43335 8 2.43335C8.84188 2.43335 9.62969 2.59147 10.3635 2.90772C11.0972 3.22395 11.7397 3.65771 12.291 4.20898C12.8423 4.76027 13.2761 5.40279 13.5923 6.13655C13.9085 6.87031 14.0667 7.65812 14.0667 8.5C14.0667 9.33504 13.9085 10.1212 13.5923 10.8583C13.2761 11.5955 12.8423 12.2397 12.291 12.791C11.7397 13.3423 11.0972 13.7761 10.3635 14.0923C9.62969 14.4085 8.84188 14.5667 8 14.5667ZM8 13.6692C8.24018 13.4291 8.46539 13.0378 8.67565 12.4955C8.88591 11.9532 9.04744 11.3487 9.16027 10.682H6.83973C6.9611 11.3658 7.12478 11.9788 7.33077 12.5212C7.53674 13.0635 7.75982 13.4462 8 13.6692ZM6.92567 13.5859C6.71456 13.2526 6.52396 12.8329 6.35387 12.3269C6.18378 11.8209 6.05343 11.2726 5.96283 10.682H3.2846C3.63674 11.4521 4.13397 12.0921 4.77628 12.6019C5.41861 13.1118 6.13507 13.4398 6.92567 13.5859ZM9.07433 13.5859C9.86493 13.4398 10.5814 13.1118 11.2237 12.6019C11.866 12.0921 12.3633 11.4521 12.7154 10.682H10.0372C9.9252 11.2769 9.78417 11.8273 9.61408 12.3333C9.44399 12.8393 9.26408 13.2568 9.07433 13.5859ZM2.98205 9.8154H5.87693C5.84617 9.57865 5.82694 9.34681 5.81925 9.11988C5.81156 8.89295 5.80772 8.67521 5.80772 8.46667C5.80772 8.25812 5.81156 8.04594 5.81925 7.83012C5.82694 7.61431 5.84617 7.39913 5.87693 7.1846H2.98205C2.91795 7.39999 2.87158 7.61879 2.84295 7.84102C2.81432 8.06324 2.8 8.2829 2.8 8.5C2.8 8.7171 2.81432 8.93676 2.84295 9.15898C2.87158 9.38121 2.91795 9.60001 2.98205 9.8154ZM6.76025 9.8154H9.23975C9.27052 9.56753 9.28975 9.33783 9.29745 9.12628C9.30514 8.91475 9.30898 8.70599 9.30898 8.5C9.30898 8.29401 9.30514 8.08247 9.29745 7.86538C9.28975 7.64828 9.27052 7.42136 9.23975 7.1846H6.76025C6.72948 7.42136 6.71025 7.64828 6.70255 7.86538C6.69486 8.08247 6.69102 8.29401 6.69102 8.5C6.69102 8.70599 6.69486 8.91753 6.70255 9.13462C6.71025 9.35172 6.72948 9.57865 6.76025 9.8154ZM10.1231 9.8154H13.018C13.0821 9.60001 13.1284 9.38121 13.1571 9.15898C13.1857 8.93676 13.2 8.7171 13.2 8.5C13.2 8.2829 13.1857 8.06046 13.1571 7.83268C13.1284 7.60491 13.0821 7.38888 13.018 7.1846H10.1231C10.1538 7.42136 10.1731 7.65319 10.1807 7.88012C10.1884 8.10705 10.1923 8.32479 10.1923 8.53333C10.1923 8.74188 10.1884 8.95406 10.1807 9.16988C10.1731 9.38569 10.1538 9.60087 10.1231 9.8154ZM10.0372 6.31797H12.7154C12.359 5.53932 11.865 4.89936 11.2333 4.39807C10.6017 3.89679 9.88203 3.56666 9.07433 3.40768C9.28544 3.76238 9.47391 4.18952 9.63972 4.6891C9.80554 5.18868 9.93802 5.73163 10.0372 6.31797ZM6.83973 6.31797H9.16027C9.0389 5.63848 8.87202 5.02223 8.65962 4.46923C8.44723 3.91624 8.22736 3.53676 8 3.33077C7.77264 3.53676 7.55277 3.91624 7.34038 4.46923C7.12798 5.02223 6.9611 5.63848 6.83973 6.31797ZM3.2846 6.31797H5.96283C6.06198 5.73163 6.19446 5.18868 6.36028 4.6891C6.52609 4.18952 6.71456 3.76238 6.92567 3.40768C6.1137 3.56666 5.39297 3.89786 4.76347 4.40128C4.13398 4.90471 3.64102 5.5436 3.2846 6.31797Z"
              fill="currentColor"
            />
          </svg>
          {locale && locales[locale].label}
        </p>
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          xmlns="http://www.w3.org/2000/svg"
          className="transition-transform duration-150 text-muted"
          style={{
            transform: open ? "rotate(180deg)" : "",
          }}
        >
          <path
            d="M7.99992 9.67055L12.8217 4.84875C12.9431 4.72738 13.0924 4.66562 13.2698 4.66348C13.4471 4.66135 13.5965 4.72096 13.7179 4.84233C13.8392 4.9637 13.8999 5.11305 13.8999 5.2904C13.8999 5.46774 13.8392 5.6171 13.7179 5.73846L8.75375 10.709C8.64435 10.8184 8.52598 10.8966 8.39863 10.9436C8.27128 10.9906 8.13837 11.0141 7.99992 11.0141C7.86146 11.0141 7.72856 10.9906 7.6012 10.9436C7.47386 10.8966 7.35548 10.8184 7.24608 10.709L2.28199 5.74488C2.16062 5.62351 2.09886 5.47308 2.09672 5.29359C2.09458 5.11412 2.1542 4.9637 2.27557 4.84233C2.39693 4.72096 2.54629 4.66028 2.72363 4.66028C2.90098 4.66028 3.05033 4.72096 3.1717 4.84233L7.99992 9.67055Z"
            fill="currentColor"
          />
        </svg>
      </button>
      <div
        className="absolute flex flex-col w-full top-full translate-y-[1px] left-0 ring-1 ring-muted bg-background transition-all duration-150"
        style={{
          visibility: open ? "visible" : "hidden",
          opacity: open ? "1" : "0",
        }}
      >
        {Object.keys(locales).map((code) => {
          if (code === locale) return null;

          let query: any =
            (typeof window !== "undefined" ? window.location.search : "") ?? "";

          query = query
            .slice(1, query.length)
            .split("&")
            .filter((e) => e);

          let queryObject: any = {};

          for (let entry of query) {
            let [key, value] = entry.split("=");
            queryObject[key] = value;
          }
          queryObject["locale"] = code;

          query = "";
          for (let key in queryObject) {
            query += `${key}=${queryObject[key]}&`;
          }

          query = query.slice(0, -1);

          let url: string =
            (alternativeUrls
              ? alternativeUrls[code]
              : uri(routeNames[currentRouteName], currentParams, code)) +
            "?" +
            query;

          return (
            <a key={locale} className="w-full px-5 py-3" href={url}>
              {locales[code].label}
            </a>
          );
        })}
      </div>
    </div>
  );
}
